export default __webpack_public_path__ + "static/media/sensotrend_signin_create_account.a5cc429c.png";